import type { AttributionIdentifiers } from './types';

const BUILTIN_CLICK_PARAMS = [
  'fbclid',
  'gclid',
  'gbraid',
  'wbraid',
  'ttclid',
  'msclkid',
  'epik',
  'li_fat_id',
] as const;

/**
 * Parses click IDs from URL search params and maps to AttributionIdentifiers fields.
 */
export class ClickIdParser {
  parse(customParams: readonly string[] = []): Partial<AttributionIdentifiers> {
    if (typeof window === 'undefined' || !window.location?.search) {
      return {};
    }

    try {
      const params = new URLSearchParams(window.location.search);
      const result: Record<string, unknown> = {};
      const customClickIds: Record<string, string> = {};

      for (const key of BUILTIN_CLICK_PARAMS) {
        const value = params.get(key);
        if (!value) continue;

        if (key === 'li_fat_id') {
          result.liFatId = value;
        } else {
          result[key] = value;
        }
      }

      for (const key of customParams) {
        const value = params.get(key);
        if (value) customClickIds[key] = value;
      }

      if (Object.keys(customClickIds).length > 0) {
        result.customClickIds = customClickIds;
      }

      return result as Partial<AttributionIdentifiers>;
    } catch {
      return {};
    }
  }

  /**
   * Meta convention: when fbclid is present and _fbc cookie is missing,
   * synthesize fbc = fb.1.<timestamp_ms>.<fbclid>
   */
  synthesizeFbc(fbclid: string, existingFbc?: string): string | undefined {
    if (existingFbc) return existingFbc;
    if (!fbclid) return undefined;
    return `fb.1.${Date.now()}.${fbclid}`;
  }
}
